import { motion } from 'framer-motion'
import { BOOKING_URL, GOOGLE_PROFILE_URL } from '../../data/site'

const GOOGLE_REVIEWS_URL =
  GOOGLE_PROFILE_URL ||
  'https://www.google.com/maps/search/?api=1&query=Recreo+Rehab+161+Eglinton+Ave+E+Toronto'

const GoogleIcon = () => (
  <svg className="w-5 h-5 flex-shrink-0" viewBox="0 0 24 24" aria-hidden="true">
    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
  </svg>
)

const GoogleReviews = () => {
  return (
    <section className="bg-cream-100 py-20 md:py-28">
      <motion.div
        className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-40px' }}
        transition={{ duration: 0.7, ease: 'easeOut' }}
      >
        <div className="flex items-center justify-center gap-2 mb-4">
          <GoogleIcon />
          <span className="font-sans text-dark-500 text-xs tracking-[0.15em] uppercase font-medium mt-[2px]">
            Google Reviews
          </span>
        </div>
        <h2 className="font-display text-dark-700 text-3xl md:text-4xl lg:text-5xl font-semibold mb-5">
          Hear from our community
        </h2>
        <p className="font-sans text-dark-500 text-base md:text-lg leading-relaxed mb-10">
          See what clients say about their care at Recreo Rehab, and share your
          own experience after your visit.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-3">
          <a
            href={GOOGLE_REVIEWS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 border border-dark-700 rounded-full px-6 py-3 font-sans text-sm tracking-[0.15em] uppercase text-dark-700
                       hover:bg-dark-700 hover:text-white transition-all duration-200"
          >
            Read our reviews on Google
            <span aria-hidden="true">→</span>
          </a>
          <a
            href={BOOKING_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-brand-orange-500 text-white rounded-full px-6 py-3 font-sans text-sm tracking-[0.15em] uppercase
                       hover:bg-brand-orange-400 transition-colors duration-200"
          >
            Book a visit
          </a>
        </div>
      </motion.div>
    </section>
  )
}

export default GoogleReviews
